import { Result } from "@cartographerio/fp";
import { attachmentField, form, numberField, page, required, section, timestampField, } from "@cartographerio/topo-form";
import { attachmentFolderSchema, nullableSchema, numberSchema, pointSchema, productSchema, timestampSchema, } from "@cartographerio/topo-survey";
import { unsafeSurveyModuleId, } from "@cartographerio/types";
export const moduleId = unsafeSurveyModuleId("TestSurvey2");
export const names = {
    shortName: "Survey 2",
    longName: "Test Survey 2",
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function dataDescription(_data) {
    return Result.pure("Test Survey 2");
}
export function dataGeometry(data) {
    return Result.pure(data.location);
}
export function dataTimestamp(data) {
    return Result.pure(data.timestamp);
}
export function copyData(data) {
    return Result.pure({ ...data, timestamp: undefined });
}
/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-explicit-any */
export const dataSchema = productSchema({
    location: nullableSchema(pointSchema),
    timestamp: nullableSchema(timestampSchema),
    a: nullableSchema(numberSchema),
    b: nullableSchema(numberSchema),
    c: nullableSchema(numberSchema),
    photographs: attachmentFolderSchema,
});
export const formSchema = form({
    title: names.shortName,
    pages: [
        page({
            title: null,
            path: [],
            blocks: [
                section({
                    title: null,
                    path: [],
                    blocks: [
                        timestampField({
                            label: "Date/Time",
                            path: ["data", "timestamp"],
                            required: required("info"),
                            defaultValue: "now",
                        }),
                        numberField({
                            label: "A",
                            path: ["data", "a"],
                            required: required("info"),
                        }),
                        numberField({
                            label: "B",
                            path: ["data", "b"],
                            required: required("info"),
                        }),
                        numberField({
                            label: "C",
                            path: ["data", "c"],
                            required: required("info"),
                        }),
                        attachmentField({
                            label: "Photographs",
                            path: ["data", "photographs"],
                            fullWidth: true,
                            maxFiles: 4,
                        }),
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=parts.js.map